export const ROUTES = {
  login: "/login",
  dashboard: "/",
  messages: "/messages",
  calls: "/calls",
  contacts: "/contacts",
  settings: "/settings",
  uiKit: "/ui",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
